import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-input-suffix',
  templateUrl: './input-suffix.component.html',
  styleUrls: ['./input-suffix.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputSuffixComponent {}
